import { Component, h } from 'preact';
import Tock from 'tocktimer';

import Countdown from './Countdown';
import Office from './Office';
import ResultJumpForm from './ResultJumpForm';

class ResultsApp extends Component {
  constructor() {
    super();

    this.state = {
      offices: [],
      timeLeft: null,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  onComplete() {
    this.fetchData();
  }

  fetchData() {
    return fetch(this.props.url)
      .then(res => res.json())
      .then(offices => this.setState({ offices }));
  }

  componentDidMount() {
    this.fetchData();
  }

  render({}, { offices, timeLeft }) {
    const choices = offices.map(office => {
      const name =
        office.division_type === 'statewide' && office.office !== 'U.S. Senate'
          ? office.officeholder_label
          : office.office;
      return { value: office.office_slug, name };
    });

    return (
      <div class="results">
        <div id="results__bar" class="results__bar">
          <ResultJumpForm choices={choices} />
          <Countdown onComplete={this.fetchData} />
        </div>
        <div class="results__offices">
          {offices.map(office => (
            <Office key={office.office_slug} {...office} />
          ))}
        </div>
      </div>
    );
  }
}

export default ResultsApp;



// WEBPACK FOOTER //
// ./components/ResultsApp.js